<div class="row col-12 ml-0 p-0">
    <div id="fullPageLoader" [ngClass]="showLoader?'show-loader':'hide-loader'">
        <div class="loader"></div>
    </div>
    <div class="col-12 pt-3 p-0">
        <ag-grid-angular id="ttgaGrid" class="ag-theme-alpine"
                         [gridOptions]="gridOptions"
                         [columnDefs]="columnDefs"
                         [defaultColDef]="defaultColDef"
                         [rowData]="rowData"
                         [domLayout]="domLayout"
                         (gridReady)="onGridReady($event)"
                         [overlayLoadingTemplate]="loadingTemplate"
                         [overlayNoRowsTemplate]="noRowsTemplate"
                         [suppressColumnMoveAnimation]="true"
                         [suppressPaginationPanel]=true
                         [detailRowAutoHeight]="detailRowAutoHeight"
                         (selectionChanged)="onSelectionChanged()"
                         [accentedSort]="true">
        </ag-grid-angular>
    </div>
    <div *ngFor="let s of sizes" class="{{s.css + ' ' + (prefix + s.id) }}"></div>
    <button *ngIf="!isSelectMode" class="btn btn-primary btn-md mt-2 mr-2 ml-auto float-right" (click)="toggleSelectMode()">Select & Delete</button>
    <div *ngIf="showCreateNewButton && !isSelectMode" class="my-button-container mt-2">
        <a class="btn btn-primary btn-md" href="#" data-toggle="modal" data-target="#modal-max-alert">Create New</a>
    </div>
    <div *ngIf="!showCreateNewButton && !isSelectMode" class="my-button-container mt-2">
        <a class="btn btn-primary btn-md" href="?action=CreateNewExist">Create New</a>
    </div>
    <a id="deleteButton" *ngIf="isSelectMode" [class.disabled]="!isRowSelected" class="btn btn-primary btn-md mt-2 float-right mr-2 ml-auto" data-toggle="modal" data-target="#modal-multi-delete-alert">Delete Selected</a>
    <button *ngIf="isSelectMode" class="btn btn-primary btn-md mt-2 float-right mr-2" (click)="toggleSelectMode()">Cancel</button>

    <div id="modal-multi-delete-alert"
         class="modal fade"
         tabindex="-1"
         role="dialog"
         #deleteModal>
        <div class="modal-dialog modal-lg modal-dialog-scrollable m-centered"
             role="document">
            <div class="modal-content">
                <div class="modal-header">
                </div>
                <div class="modal-body text-center">
                    <h5>{{deleteAlertMessage}}</h5>
                    <button class="btn btn-primary btn-md mt-2 mr-2" (click)="deleteSelectedItems(); closeModal()">Delete</button>
                    <button class="btn btn-primary btn-md mt-2" (click)="closeModal()" data-dismiss="modal">Cancel</button>
                </div>
                <div class="modal-footer">
                </div>
            </div>
        </div>
    </div>
</div>

